<template>
    <div v-if="props.location">{{ props.location }}</div>
</template>
<script setup lang="ts">
    const props = defineProps<{
        location?: string;
    }>();
</script>
